export const environment = {
  production: true,

  // Rest API
  restBaseUrl: 'https://vanenet.eu',
  restEndpoints: {
    EMPTY: '/assets/empty.json'
  }
};



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/environments/environment.ts